export var CreditoPjTrackingEvent;
(function (CreditoPjTrackingEvent) {
    CreditoPjTrackingEvent["VIEW_LANDING"] = "credito_pj_antecipacao_landing";
    CreditoPjTrackingEvent["VIEW_LOADER"] = "credito_pj_antecipacao_loader";
    CreditoPjTrackingEvent["VIEW_UNAVAILABLE"] = "credito_pj_antecipacao_indisponivel";
    CreditoPjTrackingEvent["VIEW_APPROVED"] = "credito_pj_antecipacao_aprovado";
    CreditoPjTrackingEvent["VIEW_UNAVAILABLE_LOGIN_FAILURE"] = "credito_pj_antecipacao_indisponivel_falha_login";
    CreditoPjTrackingEvent["ACTION_CONTINUE_PARTNER"] = "credito_pj_antecipacao_continuar_parceiro";
    CreditoPjTrackingEvent["ACTION_START_SIMULATION"] = "credito_pj_antecipacao_iniciar_simulacao";
    CreditoPjTrackingEvent["ACTION_SIMULATE_NOW"] = "credito_pj_antecipacao_simular_agora";
    CreditoPjTrackingEvent["ACTION_BACK"] = "credito_pj_antecipacao_retorno";
    CreditoPjTrackingEvent["ACTION_FAQ"] = "credito_pj_antecipacao_faq";
})(CreditoPjTrackingEvent || (CreditoPjTrackingEvent = {}));
